import type { FC } from 'react'
import styled from 'styled-components'

import { Button, AlternateButton } from '@/components/DEPRECATED_UI/Button'
import PreviewResult from '@/components/PreviewResult'
import { toErrorNode, useGetOverrideIncomeResultQuery } from '@/lib/apollo'

import type { OverrideIncomeRequest } from './types'

interface Props {
  overrideIncomeRequest: OverrideIncomeRequest
  onConfirm: () => void
  onBack: () => void
}

const Container = styled.div`
  display: grid;
  grid-gap: 10px;
  height: 100%;
  grid-template-rows: 1fr min-content;
`

const PreviewStep: FC<Props> = ({ overrideIncomeRequest, onConfirm, onBack }) => {
  const { loading, error, data } = useGetOverrideIncomeResultQuery({
    variables: {
      overrideIncomeRequest,
    },
    fetchPolicy: 'network-only',
  })

  return (
    <Container>
      {error ? (
        toErrorNode(error)
      ) : loading || data === undefined || data.getOverrideIncomeResult == null ? (
        <>Loading. This may take a few minutes.</>
      ) : (
        <PreviewResult
          totalAmountVerified={data.getOverrideIncomeResult.totalAmountVerified}
          outcomeStatus={data.getOverrideIncomeResult.outcomeStatus}
          decisionComments={data.getOverrideIncomeResult.decisionComments}
        />
      )}
      <div>
        <AlternateButton onClick={onBack}>Back</AlternateButton>
        <Button disabled={loading || data === undefined} onClick={onConfirm}>
          Confirm and verify
        </Button>
      </div>
    </Container>
  )
}

export default PreviewStep
